import _sfc_main from "./Group.vue.mjs";
import _sfc_main$1 from "./Item.vue.mjs";
const ReorderGroup = _sfc_main;
const ReorderItem = _sfc_main$1;
const Reorder = {
  Group: _sfc_main,
  Item: _sfc_main$1
};
export {
  Reorder,
  ReorderGroup,
  ReorderItem
};
